import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './ThankYouForLettingUsKnowModal.scss';

export default class ThankYouForLettingUsKnowModal extends Component {
    static get propTypes() {
        return {
            userId: PropTypes.number,
            requestId: PropTypes.number,
            phone: PropTypes.string
            // showHomeLoansBlock: PropTypes.bool TODO:: Remove UHL
        };
    }

    state = {
        isLoading: false,
        isUpdatingPhone: false,
        phone: this.props.phone || '',
    };
    phoneInputRef = React.createRef();

    handlePhoneChangeFormSubmit(event) {
        event.preventDefault();

        const $phoneInput = $(this.phoneInputRef.current);
        if (!$phoneInput.valid()) {
            return;
        }

        $.post('update-user-json', {
            userId: this.props.userId,
            phone: this.state.phone
        }).then(data => {
            checkAjax(data);
        }).fail(() => {
            defaultAjaxError();
        });

        this.setState({isUpdatingPhone: false});
    }

    handlePhoneInput(event) {
        const phone = returnNumbersOnly(returnPhoneFormat(event.target.value));
        this.setState({phone});
    }

    render() {
        const {isUpdatingPhone, isLoading, phone} = this.state;
        return (
            <form className="modal nu-modal mod also-buying-confirmation-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="mt-2x-sm mb-4x text-center">
                                    <img src={global.imageBaseUrl + 'proposal/cart_squircle_blue.svg'} alt='Cart icon'/>
                                </div>
                                Thanks for letting us know!
                            </div>
                        </div>
                        <div className="modal-body">
                            {isUpdatingPhone ? (
                                <form className="mt-3x mb-5x mb-7x-sm phone-change-form"
                                    onSubmit={this.handlePhoneChangeFormSubmit.bind(this)}>
                                    <div className="inputs">
                                        <input
                                            ref={this.phoneInputRef}
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            className="form-control phoneUS"
                                            value={returnPhoneFormat(phone)}
                                            onInput={this.handlePhoneInput.bind(this)}
                                        />
                                        <input
                                            type="submit"
                                            className="btn btn-blue"
                                            value="Change"
                                            disabled={!phone || phone.length < 10}
                                        />
                                    </div>
                                    <label htmlFor="phone" className="error" generated="true" style="display: none"/>
                                </form>
                            ) : (
                                <div className="message">
                                    {/*TODO:: Remove UHL*/}
                                    {/*{this.props.showHomeLoansBlock ? (*/}
                                    {/*    <> Your UpNest home loan specialist will call you at {' '}*/}
                                    {/*        <span*/}
                                    {/*            className="text-bold text-nowrap">{returnPhoneFormat(phone)}</span>{' '}*/}
                                    {/*        shortly to discuss your options.</>*/}
                                    {/*) : (*/}
                                        <> Your UpNest advisor will call you at {' '}
                                            <span
                                                className="text-bold text-nowrap">{returnPhoneFormat(phone)}</span>{' '}
                                            shortly to discuss your needs.</>
                                    {/*)}*/}

                                    <div className="mt-2x mb-3x mb-5x-sm">
                                        <a className="phone-change"
                                            onClick={() => this.setState({isUpdatingPhone: true})}>
                                            Call me at another number
                                        </a>
                                    </div>
                                    <div className="divider"/>
                                    {/*TODO:: Remove UHL*/}
                                    {/*{this.props.showHomeLoansBlock && (*/}
                                    {/*    <div className="home-loans-block">*/}
                                    {/*        <div className="text-center home-loan-calculator-message">If you want to get a head start,*/}
                                    {/*            <a href="https://upnesthomeloans.com/calculator?utm_source=Buyer&utm_medium=web&utm_campaign=homeloanquestion"*/}
                                    {/*                onClick={() => {*/}
                                    {/*                    trackEvent('Proposal', 'buyerClickedLoanCalculatorCTA', 'buyerClickedLoanCalculatorCTA').withGA();*/}
                                    {/*                }}*/}
                                    {/*                target="_blank" rel="noreferrer"> click here <br/>to checkout our loan calculator</a>  or get a <span className="text-nowrap">Pre-Approval</span> letter.*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*)}*/}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-gray-outline" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                        {isLoading && (
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'} alt={'Loading spinner'}/>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    }
}
